export default "__VITE_ASSET__CIKDWcec__"